import { useToast } from "./toast-context";
import { ToastCard } from "./ToastCard";
import { MAX_VISIBLE } from "./types";

export const ToastStack = () => {
  const { toasts } = useToast();

  const visible = toasts.filter((t) => !t._exiting).slice(0, MAX_VISIBLE);
  const exiting = toasts.filter((t) => t._exiting);
  const all = [...visible, ...exiting];

  if (all.length === 0) return null;

  return (
    <div
      className="fixed z-[9999] flex flex-col gap-2.5 pointer-events-none"
      style={{
        top: 20,
        right: 20,
        width: "min(360px, calc(100vw - 24px))",
        minWidth: 320,
        maxWidth: 380,
      }}
    >
      {all.map((toast) => (
        <div key={toast.id} className="pointer-events-auto">
          <ToastCard toast={toast} />
        </div>
      ))}
    </div>
  );
};
